import { Component, OnInit } from '@angular/core';
import { Subject, takeUntil } from "rxjs";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { MenuService } from "../../../services/menus/menu.service";

@Component({
  selector: 'app-delete-task-rate',
  templateUrl: './delete-task-rate.component.html',
  styleUrls: ['./delete-task-rate.component.scss']
})
export class DeleteTaskRateComponent implements OnInit {

  //#region Fields
  public taxRateId: string;
  public spinner: boolean = false;
  public unsubscribe: Subject<void> = new Subject<void>();
  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private menuService: MenuService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.taxRateId = this.config.data.id;
    }
  }

  public ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  public deleteTaxRate(taxRateId: string): void {
    this.spinner = true;
    this.menuService.deleteTaxRate(taxRateId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: _ => {
          this.ref.close({item: true});
        },
        error: errorResponse => {
          this.spinner = false;
          this.ref.close({item: false, error: errorResponse});
        }
      });
  }

  public cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
